import { render, staticRenderFns } from "./FormInputNumber.vue?vue&type=template&id=5c6acc5c&scoped=true&"
import script from "./FormInputNumber.vue?vue&type=script&lang=js&"
export * from "./FormInputNumber.vue?vue&type=script&lang=js&"
import style0 from "./FormInputNumber.vue?vue&type=style&index=0&id=5c6acc5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6acc5c",
  null
  
)

export default component.exports